/**
 * 无障碍属性（ARIA）本地工具
 *
 * 从 @jdx/testing-config/playwright/presets/a11y-attrs 提取的子集，
 * 仅供 src/ 生产代码使用，避免 webpack 打包时依赖 @jdx/testing-config/playwright。
 */

export const A11Y_ROLES = {
  button: (label: string) => ({ role: 'button', 'aria-label': label }),
  dialog: (label: string) => ({ role: 'dialog', 'aria-label': label, 'aria-modal': 'true' }),
  table: (label: string) => ({ role: 'table', 'aria-label': label }),
  form: (label: string) => ({ role: 'form', 'aria-label': label }),
  link: (label: string) => ({ role: 'link', 'aria-label': label }),
  navigation: (label: string) => ({ role: 'navigation', 'aria-label': label }),
  region: (label: string) => ({ role: 'region', 'aria-label': label }),
  radio: (label: string, checked: boolean = false) => ({
    role: 'radio',
    'aria-label': label,
    'aria-checked': checked,
  }),
  menuitem: (label: string) => ({ role: 'menuitem', 'aria-label': label }),
} as const;
